if (!customElements.get('product-upsell')) {
  class ProductUpsell extends HTMLElement {
    constructor() {
      super();
      // Store bound handlers for cleanup
      this.boundHandleAddToCart = this.handleAddToCart.bind(this);
    }

    connectedCallback() {
      this.initialize();
      this.setupAddToCartListeners();
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.addToCartButtons) {
        this.addToCartButtons.forEach(button => {
          button.removeEventListener('click', this.boundHandleAddToCart);
        });
      }
    }

    initialize() {
      this.cartDrawer = document.querySelector('cart-drawer');
      this.addToCartButtons = document.querySelectorAll('.product-form__submit');

      // Create debounced version of addItemsToCart
      this.debouncedAddItemsToCart = this.debounce((items, button) => {
        this.addItemsToCart(items, button);
      }, ON_CHANGE_DEBOUNCE_TIMER);
    }

    // Debounce utility function
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    // Set up listeners for add-to-cart buttons
    setupAddToCartListeners() {
      this.addToCartButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          // Prevent multiple clicks while processing
          if (button.classList.contains('loading')) {
            return;
          }
          this.boundHandleAddToCart(button);
        });
      });
    }

    // Handle add-to-cart process, updating UI and sending items to cart
    handleAddToCart(button) {
      this.showLoadingState(button);
      const selectedItems = this.getSelectedProducts();
      this.addMainProduct(selectedItems);

      this.debouncedAddItemsToCart(selectedItems, button);
    }

    // Adds the main product based on the current variant selection
    addMainProduct(selectedItems) {
      const productId = document.querySelector('.product-variant-id').value;
      selectedItems.push({ id: productId, quantity: 1 });
    }

    // Get selected products from inputs
    getSelectedProducts() {
      return [...document.querySelectorAll('[data-upsell-input]')]
        .filter(input => {
          if (input.type === 'checkbox') {
            return input.checked;
          } else if (input.tagName === 'SELECT') {
            return input.value && input.value !== '';
          }
          return false;
        })
        .map(input => ({ id: input.value, quantity: 1 }));
    }

    // Send async requests to add each selected item to the cart
    async addItemsToCart(items, button) {
      for (const item of items) {
        await this.sendAddToCartRequest(item);
      }
      await this.updateCartDrawer();
      await this.cartDrawer.open();
      this.hideLoadingState(button);
    }

    // Send individual add-to-cart request for an item
    async sendAddToCartRequest(item) {
      const formData = { items: [item] };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });
        const data = await response.json();
        console.log('Added item to cart:', data);
      } catch (error) {
        console.error('Error adding item to cart:', error);
      }
    }

    // Update the cart drawer content
    async updateCartDrawer() {
      const sectionsToUpdate = [
        { sectionId: 'cart-drawer', selector: '.cart-drawer .drawer__inner', targetSelector: '.drawer__inner' },
        { sectionId: 'cart-icon-bubble', selector: '.shopify-section', targetSelector: '#cart-icon-bubble' }
      ];

      for (const section of sectionsToUpdate) {
        const newHTML = await this.fetchSection(section.sectionId);
        const updatedSection = new DOMParser().parseFromString(newHTML, 'text/html').querySelector(section.selector);
        const currentContent = document.querySelector(section.targetSelector);

        if (currentContent && updatedSection) {
          if (currentContent.innerHTML !== updatedSection.innerHTML) {
            currentContent.innerHTML = updatedSection.innerHTML;
          }
        }
      }

      this.cartDrawer.classList.remove('is-empty');
    }

    // Fetch the updated cart drawer section from Shopify
    async fetchSection(sectionId = 'cart-drawer') {
      const response = await fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`);
      return response.text();
    }


    // Shows the loading state on the button
    showLoadingState(button) {
      button.classList.add('loading');
      button.querySelector('.loading__spinner').classList.remove('hidden');
    }

    // Hides the loading state on the button
    hideLoadingState(button) {
      button.classList.remove('loading');
      button.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  customElements.define('product-upsell', ProductUpsell);
}
